import React from "react";
import OneSeriesByDiscoveryDate, {
  type OneSeriesByDiscoveryDateProps,
} from "./OneSeriesByDiscoveryDate";
import { oneSeriesTrendProperties } from "../TrendsUtils";

type NewFindingsByDiscoveryDateProps = Omit<
  OneSeriesByDiscoveryDateProps,
  "chartData"
>;

const NewFindingsByDiscoveryDate: React.FC<NewFindingsByDiscoveryDateProps> = ({
  timeScale,
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  widgetKey,
  setIsReadyToExport = null,
}) => {
  return (
    <OneSeriesByDiscoveryDate
      widgetKey={widgetKey}
      timeScale={timeScale}
      chartData={oneSeriesTrendProperties.newFindingsByDiscoveryDate}
      scopeToExecute={scopeToExecute}
      filterToExecute={filterToExecute}
      selectedScope={selectedScope}
      id={id}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default NewFindingsByDiscoveryDate;
